import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import ServicesSection from '../components/ServicesSection';
import GallerySection from '../components/GallerySection';
import FindUsSection from '../components/FindUsSection';
import Footer from '../components/Footer';
import ScrollToTop from '../components/ScrollToTop';

const Home: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Hero />
      <ServicesSection />
      <FindUsSection />
      <GallerySection />
      <Footer />
    </>
  );
};

export default Home;
